import {match} from 'ts-pattern';

import {always} from 'ramda';

import {TypeOfSale} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {COUNTRY_CZE} from '@dms/shared';

import {Nullish} from 'shared/web';

/**
 * The predefined note texts reference the Czech VAT Act and are only legally
 * accurate for tenants registered in CZE — other tenant countries have no
 * verified equivalent yet, so they fall through to no predefined note.
 *
 * `tenantCountry` must be the raw, unfallbacked tenant country (e.g.
 * `useTenant().tenant?.country`, not `useTenant().tenantCountry`, which
 * defaults to CZE while the tenant query is loading or errored).
 */
export const getPredefinedNote = (
  typeOfSale: TypeOfSale | Nullish,
  tenantCountry: string | Nullish
) =>
  match([tenantCountry, typeOfSale])
    .with([COUNTRY_CZE, 'inland'], always(i18n.t('entity.checkout.labels.specialRegimeUsedGoods')))
    .with([COUNTRY_CZE, 'inEurope'], always(i18n.t('entity.checkout.labels.taxFreeSaleToEurope')))
    .with(
      [COUNTRY_CZE, 'outOfEurope'],
      always(i18n.t('entity.checkout.labels.taxFreeSaleOutsideEurope'))
    )
    .otherwise(always(null));
